import React, { useCallback } from 'react';
import { View } from 'react-native';
import { Button, CardView, rem, Spacer } from 'design-system';
import Amount from 'design-system/Amount';
import { IconRocket } from 'design-system/icons/IconRocket';
import StatusIcon from 'design-system/StatusIcon';
import Text from 'design-system/Text';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { formatETADateForItem } from 'utils/formatting';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const PendingAutosaveActivityCard = ({ activity, noMarginTop = true }) => {
    const styles = useStyles(styleSet);
    const navigation = useMainStackNavigation();
    const etaDate = activity.completedEta || activity.completedAt;
    const handleUpcomingPaymentCardPress = useCallback(() => {
        navigation.navigateDeprecated('AutosaveActivityTimeline', {
            activity: activity,
        });
    }, [activity]);
    return (<CardView noMarginTop={noMarginTop} withPadding noMarginBottom>
      <View style={styles.row}>
        <View style={styles.iconContainer}>
          <IconRocket colorKey="brand"/>
        </View>
        <Spacer.W16 />
        <View style={styles.flex}>
          <View style={styles.row}>
            <View style={styles.flex}>
              <Text Text-16>Autosave</Text>
            </View>
            <Amount showSign Numbers-16 value={activity.amount} Blue/>
          </View>
          <View style={styles.row}>
            <View style={styles.flex}>
              <View style={styles.row}>
                <StatusIcon width={16} height={16} state="in-progress"/>
                <Spacer.W8 />
                <View style={styles.flex}>
                  <Text TextThin-14 numberOfLines={1} StatusInformational>
                    Pending
                  </Text>
                </View>
              </View>
            </View>
            {!!etaDate && (<>
                <Spacer.W8 />
                <Text TextThin-14 Secondary>
                  {formatETADateForItem(new Date(etaDate))}
                </Text>
              </>)}
          </View>
        </View>
      </View>
      <Spacer h={24}/>
      <Button square brandReversed onPress={handleUpcomingPaymentCardPress} title="Track payment"/>
    </CardView>);
};
const styleSet = createStyleSheets((colors) => ({
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    flex: {
        flex: 1,
    },
    iconContainer: {
        width: rem(42),
        height: rem(42),
        borderWidth: rem(1),
        borderRadius: rem(42),
        alignItems: 'center',
        justifyContent: 'center',
        borderColor: colors.borders.logoStroke,
        backgroundColor: colors.background.brandLight,
    },
}));
export default PendingAutosaveActivityCard;
